<template>
  <div class="tool-wrap-item">
    <div class="tool-wrap-item-header">
      <el-select
        v-model="pipeType"
        class="multipleConvert"
        :class="{ hasValue: !!pipeType || !airType }"
        popper-class="supportTool-select-popper multipleConvert-select-popper"
        placeholder="管径、流量、流速计算"
        @change="pipeTypeChange"
        @focus="hideSelectInputText"
      >
        <el-option
          v-for="(item, index) in pipeTypes"
          :key="index"
          :label="item.name"
          :value="item.type"
        >
        </el-option>
      </el-select>

      <el-select
        v-model="airType"
        class="multipleConvert"
        :class="{ hasValue: !!airType }"
        popper-class="supportTool-select-popper multipleConvert-select-popper"
        placeholder="气体工况、标况流量转换"
        @change="airTypeChange"
        @focus="hideSelectInputText"
      >
        <el-option
          v-for="(item, index) in airTypes"
          :key="index"
          :label="item.name"
          :value="item.type"
        >
        </el-option>
      </el-select>
    </div>
    <div class="tool-wrap-item-content first">
      <el-table border :data="dataList" :height="520" ref="convertTable">
        <template v-if="!!pipeType || !airType">
          <!-- 管径、流量、流速计算 -->
          <el-table-column
            align="center"
            label="管道口径(mm)"
            :resizable="false"
            :key="1"
          >
            <template slot-scope="scope">
              <el-input-number
                v-if="['1', '3', '5'].includes(pipeType)"
                v-model="scope.row.pipe"
                placeholder="请输入"
                :precision="2"
                size="small"
                class="custom-input-number"
              ></el-input-number>
              <span v-else>{{ computePipe(scope.row) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="流速(m/s)"
            :resizable="false"
            :key="2"
          >
            <template slot-scope="scope">
              <el-input-number
                v-if="['1', '2', '4'].includes(pipeType)"
                v-model="scope.row.flow"
                placeholder="请输入"
                :precision="2"
                size="small"
                class="custom-input-number"
              ></el-input-number>
              <span v-else>{{ computeFlow(scope.row) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="体积流量(m³/h)"
            :resizable="false"
            :key="3"
          >
            <template slot-scope="scope">
              <el-input-number
                v-if="['2', '3'].includes(pipeType)"
                v-model="scope.row.volume"
                placeholder="请输入"
                :precision="2"
                size="small"
                class="custom-input-number"
              ></el-input-number>
              <span v-else>{{ computeVolume(scope.row) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="密度(kg/m³)"
            :resizable="false"
            :key="4"
          >
            <template slot-scope="scope">
              <el-input-number
                v-if="['1', '2', '3', '4', '5'].includes(pipeType)"
                v-model="scope.row.density"
                placeholder="请输入"
                :precision="2"
                size="small"
                class="custom-input-number"
              ></el-input-number>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="质量流量(kg/h)"
            :resizable="false"
            :key="5"
          >
            <template slot-scope="scope">
              <el-input-number
                v-if="['4', '5'].includes(pipeType)"
                v-model="scope.row.mass"
                placeholder="请输入"
                :precision="2"
                size="small"
                class="custom-input-number"
              ></el-input-number>
              <span v-else>{{ computeMass(scope.row) }}</span>
            </template>
          </el-table-column>
        </template>
        <template v-else>
          <!-- 气体工况、标况流量转换 -->
          <el-table-column
            align="center"
            label="管道口径(mm)"
            min-width="105"
            :resizable="false"
            :key="6"
          >
            <template slot-scope="scope">
              <el-input-number
                v-if="['1'].includes(airType)"
                v-model="scope.row.pipe"
                placeholder="请输入"
                :precision="2"
                size="small"
                class="custom-input-number"
              ></el-input-number>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="流速(m/s)"
            min-width="105"
            :resizable="false"
            :key="7"
          >
            <template slot-scope="scope">
              <el-input-number
                v-if="['1'].includes(airType)"
                v-model="scope.row.flow"
                placeholder="请输入"
                :precision="2"
                size="small"
                class="custom-input-number"
              ></el-input-number>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="表压(MPa)"
            min-width="105"
            :resizable="false"
            :key="8"
          >
            <template slot-scope="scope">
              <el-input-number
                v-if="['1', '2', '3'].includes(airType)"
                v-model="scope.row.pressure"
                placeholder="请输入"
                :precision="2"
                size="small"
                class="custom-input-number"
              ></el-input-number>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="温度(℃)"
            min-width="105"
            :resizable="false"
            :key="9"
          >
            <template slot-scope="scope">
              <el-input-number
                v-if="['1', '2', '3'].includes(airType)"
                v-model="scope.row.heat"
                placeholder="请输入"
                :precision="2"
                size="small"
                class="custom-input-number"
              ></el-input-number>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            min-width="105"
            label="工况流量(m³/h)"
            :resizable="false"
            :key="10"
          >
            <template slot-scope="scope">
              <el-input-number
                v-if="['2'].includes(airType)"
                v-model="scope.row.working"
                placeholder="请输入"
                :precision="2"
                size="small"
                class="custom-input-number"
              ></el-input-number>
              <span v-else>{{ computeWorking(scope.row) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            min-width="105"
            label="标况流量(Nm³/h)"
            :resizable="false"
            :key="11"
          >
            <template slot-scope="scope">
              <el-input-number
                v-if="['3'].includes(airType)"
                v-model="scope.row.standard"
                placeholder="请输入"
                :precision="2"
                size="small"
                class="custom-input-number"
              ></el-input-number>
              <span v-else>{{ computeStandard(scope.row) }}</span>
            </template>
          </el-table-column>
        </template>
      </el-table>
    </div>
  </div>
</template>

<script>
import Decimal from 'decimal.js' // + - * / ^ = plus minus times div pow

export default {
  data () {
    return {
      // 管径、流量、流速计算
      pipeType: '',
      pipeTypes: [
        {
          name: '已知管道口径和流速、密度，分别计算体积流量、质量流量',
          type: '1'
        },
        { name: '已知流速和体积流量、密度，计算管道口径', type: '2' },
        { name: '已知管道口径和体积流量，计算流速、质量流量', type: '3' },
        { name: '已知质量流量、密度和流速，计算体积流量和管道口径', type: '4' },
        { name: '已知质量流量、密度和管道口径，计算体积流量和流速', type: '5' }
      ],
      // 气体工况、标况流量转换
      airType: '',
      airTypes: [
        {
          name: '已知管道口径、流速、表压、温度，计算工况流量和标况流量',
          type: '1'
        },
        { name: '已知表压、温度和工况流量，计算标况流量', type: '2' },
        { name: '已知表压、温度和标况流量，计算工况流量', type: '3' }
      ],
      // 多参数换算table
      dataList: []
    }
  },
  methods: {
    // 多参数换算
    pipeTypeChange () {
      this.airType = ''
      this.hideSelectInputText()
      this.$nextTick(() => {
        this.$refs.convertTable.doLayout()
        this.clearConvertInput()
      })
    },
    // 多参数换算
    airTypeChange () {
      this.pipeType = ''
      this.hideSelectInputText()
      this.$nextTick(() => {
        this.$refs.convertTable.doLayout()
        this.clearConvertInput()
      })
    },
    // 下拉失焦触发文案隐藏显示...
    hideSelectInputText () {
      this.$nextTick(() => {
        Array.from(document.querySelectorAll('.multipleConvert input')).forEach(
          (item) => {
            item.blur()
          }
        )
      })
    },
    // 清空多参数换算的数值
    clearConvertInput () {
      if (this.dataList.length === 0) {
        // 推送初始值
        this.dataList.push({
          pipe: undefined, // 管道口径
          flow: undefined, // 流速
          volume: undefined, // 体积流量
          density: undefined, // 密度
          mass: undefined, // 质量流量
          pressure: undefined, // 表压
          heat: undefined, // 温度
          working: undefined, // 工况流量
          standard: undefined // 标况流量
        })
      } else {
        // 清空所有字段
        const dataList = this.dataList[0]
        for (let key in dataList) {
          dataList[key] = undefined
        }
      }
    },
    /**
     * 计算函数 START
     */

    // 管道口径=(C4/3600/B4/3.14)^0.5*1000*2
    computePipe (row) {
      if (row.volume === undefined || row.flow === undefined) {
        return ''
      }

      const res = new Decimal(row.volume)
        .div(3600)
        .div(row.flow)
        .div(3.14)
        .pow(0.5)
        .times(1000)
        .times(2)

      // 判断结果是否有效
      return this.convertRes(res, row, 'pipe')
    },

    // 流速=C5/3.14/(A3/1000/2)^2/3600
    computeFlow (row) {
      if (row.pipe === undefined || row.volume === undefined) return ''

      const res = new Decimal(row.volume)
        .div(3.14)
        .div(new Decimal(row.pipe).div(1000).div(2).pow(2))
        .div(3600)

      // 判断结果是否有效
      return this.convertRes(res, row, 'flow')
    },

    /**
     * 体积流量
     * =3.14*(A3/1000/2)^2*B3*3600 [pipeType === '1']
     * =E6/D6 [else]
     */
    computeVolume (row) {
      if (this.pipeType === '1') {
        if (row.pipe === undefined || row.flow === undefined) return ''

        const res = new Decimal(3.14)
          .times(new Decimal(row.pipe).div(1000).div(2).pow(2))
          .times(row.flow)
          .times(3600)

        // 判断结果是否有效
        return this.convertRes(res, row, 'volume')
      } else {
        if (row.density === undefined || row.mass === undefined) return ''

        const res = new Decimal(row.mass).div(row.density)

        // 判断结果是否有效
        return this.convertRes(res, row, 'volume')
      }
    },

    // 质量流量=C3*D3
    computeMass (row) {
      if (row.volume === undefined || row.density === undefined) return ''

      const res = new Decimal(row.volume).times(row.density)

      // 判断结果是否有效
      return this.convertRes(res, row, 'mass')
    },

    /**
     * 工况流量
     * =3.14*(A11/1000/2)^2*B11*3600[airType === '1']
     * =F13/( ((C13+0.101325)/0.101325) * (293.15/ (D13+273.15) ) )
     */
    computeWorking (row) {
      if (this.airType === '1') {
        if (row.pipe === undefined || row.flow === undefined) return ''

        const res = new Decimal(3.14)
          .times(new Decimal(row.pipe).div(1000).div(2).pow(2))
          .times(row.flow)
          .times(3600)

        // 判断结果是否有效
        return this.convertRes(res, row, 'working')
      } else {
        if (
          row.pressure === undefined ||
          row.heat === undefined ||
          row.standard === undefined
        ) {
          return ''
        }

        const res = new Decimal(row.standard).div(
          new Decimal(row.pressure)
            .plus(0.101325)
            .div(0.101325)
            .times(new Decimal(293.15).div(new Decimal(row.heat).plus(273.15)))
        )

        // 判断结果是否有效
        return this.convertRes(res, row, 'working')
      }
    },

    // 标况流量=E11*( (C11+0.101325)/0.101325 ) * ( 293.15/(D11+273.15) )
    computeStandard (row) {
      if (
        row.pressure === undefined ||
        row.heat === undefined ||
        row.working === undefined
      ) {
        return ''
      }

      const res = new Decimal(row.working)
        .times(
          new Decimal(new Decimal(row.pressure).plus(0.101325)).div(0.101325)
        )
        .times(new Decimal(293.15).div(new Decimal(row.heat).plus(273.15)))

      // 判断结果是否有效
      return this.convertRes(res, row, 'standard')
    },

    // 结果过滤
    convertRes (res, row, field) {
      // 无穷大
      if (res === '∞' || res === Infinity || res === 'Infinity') {
        row[field] = undefined
        return '无穷大'
      }

      // 运算错误
      if (res === 'NaN' || isNaN(res)) {
        row[field] = undefined
        return '运算出错'
      }

      if (
        (row[field] && row[field].toFixed(2) !== res.toFixed(2)) ||
        row[field] === undefined
      ) {
        row[field] = res
      }

      // 返回结果
      return res.toFixed(2)
    }
    /**
     * 计算函数 END
     */
  }
}
</script>
<style lang="scss">
.multipleConvert-select-popper {
  border: 1px solid #2a54d1;
  box-shadow: 0px 9px 6px 0px rgba(0, 0, 0, 0.15);
  border-radius: 8px;

  .el-select-dropdown__list {
    padding: 8px 4px;

    .el-select-dropdown__item {
      padding: 0 8px;
      height: 32px;
      line-height: 32px;
      color: #666;
      border-radius: 4px;

      &:hover {
        background: #f1f5fb;
      }
    }
  }

  .popper__arrow {
    display: none;
  }
}
</style>
<style lang="scss" scoped>
.tool-wrap-item {
  .tool-wrap-item-header {
    background: #fff;
    margin: -19px -11px 19px -19px;
    padding: 16px 19px 0;
    border-bottom: 1px solid #eee;
  }
}

/deep/ .el-select {
  &.multipleConvert {
    position: relative;

    .el-select__caret:first-child::before {
      color: #666;
    }

    .el-input {
      input {
        border-radius: 4px 4px 0 0;
        background: #fff !important;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 14px !important;

        &::placeholder {
          color: #666;
        }
      }

      &.is-focus {
        &:before {
          content: "";
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 2px;
          background: #fff;
        }

        &:after {
          content: "";
          position: absolute;
          bottom: -2px;
          left: 0;
          width: 100%;
          height: 2px;
          background: #2a54d1;
        }

        .el-select__caret:first-child::before {
          color: #fff;
        }

        input {
          background: #2a54d1 !important;

          &::placeholder {
            color: #fff;
          }
        }
      }
    }

    // 有值的样式
    &.hasValue {
      .el-select__caret:first-child::before {
        color: #2a54d1 !important;
        font-weight: bold;
      }

      .el-input {
        &:after {
          content: "";
          position: absolute;
          bottom: -2px;
          left: 0;
          width: 100%;
          height: 2px;
          background: #2a54d1;
        }

        input {
          color: #2a54d1 !important;
          font-weight: bold;

          &::placeholder {
            color: #2a54d1;
            font-weight: bold;
          }
        }

        &.is-focus {
          .el-select__caret:first-child::before {
            color: #fff;
            font-weight: 500;
          }

          input {
            color: #fff !important;
            font-weight: 500;

            &::placeholder {
              color: #fff;
              font-weight: 500;
            }
          }
        }
      }
    }

    &:not(.hasValue) {
      .el-input {
        &.is-focus {
          &:after {
            display: none;
          }
        }
      }
    }
  }
}
</style>
